import React, { useContext } from "react";
import { Link } from "react-router-dom";

// Contexts
import { DataContext } from "contexts/Data";

const Logo = ({ color = "#fff", size = "5rem", className }) => {
    const { data, language } = useContext(DataContext);

    return (
        <Link to="/" className={`logo-link ${className}`}>
            <span> {data.title[language]}</span>
        </Link>
    );
};

export default Logo;
